import type { FormFieldErrors, IErrorModalProps } from './error.types.ts';

export interface IErrorHandling {
  errorCode: number;
  redirectPath?: string;
  relatedFieldName?: keyof FormFieldErrors;
  callBack?: () => void;
  openModal?: boolean;
  modalProps?: IErrorModalProps;
  nonUserRedirectPath?: string;
}

export interface IError {
  code: number;
  codeName: string;
  localizedMessage: string;
  message: string;
  data?: {
    url?: string;
  };
}

export interface ServerErrorResponse {
  response: {
    data: {
      errors: IError[];
      httpStatus: number;
      reasonPhrase: string;
    };
    status?: number;
  };
}

export enum OnboardingFormFields {
  EMAIL = 'EMAIL',
  PASSWORD = 'PASSWORD',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  PHONE_NUMBER = 'PHONE_NUMBER',
  PHONE_NUMBER_VALIDATION_STATUS = 'PHONE_NUMBER_VALIDATION_STATUS',
  SSN = 'SSN',
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  NATIONALITY = 'NATIONALITY',
  PASSPORT_NUMBER = 'PASSPORT_NUMBER',
  NATIONAL_ID_NUMBER = 'NATIONAL_ID_NUMBER',
  IDENTITY_NON_US_AGREEMENT_A = 'IDENTITY_NON_US_AGREEMENT_A',
  IDENTITY_NON_US_AGREEMENT_B = 'IDENTITY_NON_US_AGREEMENT_B',
  LINE1 = 'LINE1',
  APARTMENT = 'APARTMENT',
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  STATE = 'STATE',
  ZIP = 'ZIP',
  HOME_LINE_1 = 'HOME_LINE_1',
  HOME_APARTMENT = 'HOME_APARTMENT',
  HOME_CITY = 'HOME_CITY',
  HOME_COUNTRY = 'HOME_COUNTRY',
  HOME_STATE = 'HOME_STATE',
  HOME_ZIP = 'HOME_ZIP',

  INDUSTRY = 'INDUSTRY',
  SUB_INDUSTRY = 'SUB_INDUSTRY',
  BUSINESS_NAME = 'BUSINESS_NAME',
  BUSINESS_EIN = 'BUSINESS_EIN',
  BUSINESS_REGISTER_STATE = 'BUSINESS_REGISTER_STATE',
  CHECKBOX_SOLE_BENEFICIAL_AGREEMENT = 'CHECKBOX_SOLE_BENEFICIAL_AGREEMENT',
  BUSINESS_LINE_1 = 'BUSINESS_LINE_1',
  BUSINESS_APARTMENT = 'BUSINESS_APARTMENT',
  BUSINESS_CITY = 'BUSINESS_CITY',
  BUSINESS_COUNTRY = 'BUSINESS_COUNTRY',
  BUSINESS_STATE = 'BUSINESS_STATE',
  BUSINESS_ZIP = 'BUSINESS_ZIP',
  BUSINESS_ADDRESS_SAME_AS_PRIMARY = 'BUSINESS_ADDRESS_SAME_AS_PRIMARY',
  REGISTERED_ADDRESS_SAME_AS_PRIMARY = 'REGISTERED_ADDRESS_SAME_AS_PRIMARY',
  GENERIC_ERROR_FIELD = 'GENERIC_ERROR_FIELD',
  OWNER_PERCENTAGE = 'OWNER_PERCENTAGE',
  OWNER_SAME_AS_PRIMARY = 'OWNER_SAME_AS_PRIMARY',
  CHECKBOX_FINAL_AGREEMENT = 'CHECKBOX_FINAL_AGREEMENT',
  CHECKBOX_EXCHANGE_INFO = 'CHECKBOX_EXCHANGE_INFO',
  CHECKBOX_BENEFICIAL_OWNERS = 'CHECKBOX_BENEFICIAL_OWNERS',
  OWNER_CENTER_CONSENT = 'OWNER_CENTER_CONSENT',
  ACCOUNT_OPENING_REASON = 'ACCOUNT_OPENING_REASON',
  HIGH_LEVEL_BUSINESS_DESCRIPTION = 'HIGH_LEVEL_BUSINESS_DESCRIPTION',
  CUSTOMER_LOCATION = 'CUSTOMER_LOCATION',
  VENDOR_LOCATION = 'VENDOR_LOCATION',
  MONTHLY_PAYMENT_VOLUME = 'MONTHLY_PAYMENT_VOLUME',
  MONTHLY_PAYMENT_TRANSACTIONS = 'MONTHLY_TRANSACTIONS',
  ID_VERIFICATION_OTP = 'ID_VERIFICATION_OTP',
  MFA_OTP = 'MFA_OTP',
  REMEMBER_ME = 'REMEMBER_ME',
  BUSINESS_TYPE = 'BUSINESS_TYPE',
  OWNER_CENTER_UBO_1_PERCENTAGE = 'OWNER_CENTER_UBO_1_PERCENTAGE',
  OWNER_CENTER_UBO_2_PERCENTAGE = 'OWNER_CENTER_UBO_2_PERCENTAGE',
  OWNER_CENTER_UBO_3_PERCENTAGE = 'OWNER_CENTER_UBO_3_PERCENTAGE',
  OWNER_CENTER_UBO_4_PERCENTAGE = 'OWNER_CENTER_UBO_4_PERCENTAGE',
  PHONE_NUMBER_ISO_CODE = 'PHONE_NUMBER_ISO_CODE',
}

export const InputRegexMap = {
  firstName: /^[a-zA-ZÀ-ÿ-_' ]*$/,
  lastName: /^[a-zA-ZÀ-ÿ-_' ]*$/,
  phoneUS: /^\+1 \(\d{3}\) \d{3}-\d{4}$/,
  cityUS: /^[a-zA-ZÀ-ÿ-_ ]*$/,
  lineOneUS: /^[a-zA-ZÀ-ÿ0-9\-_. #|\/',]*$/,
  zipCode: /^\d+$/,
};

export enum MFA_TYPES {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export enum QueryParamsToStore {
  TOKEN = 'token',
  CUSTOMER = 'customer',
  REFERRAL = 'r',
  SOURCE = 'source',
  CUSTOMER_ID = 'id',
  CUSTOMER_ID_V2 = 'customerId',
  AUTH_ID = 'authId',
  UBO_ID = 'uboid',
  MULTI_BUSINESS_ID = 'multiBusinessId',
  EMAIL = 'email',
  PARTNER = 'partner',
  LOGIN_TOKEN = 'loginToken',
  CONTINUE_MULTI_BUSINESS = 'continueMultiBusiness',
}

export interface IPartnerDataResponse {
  customerId: string;
  partnerId: string;
  email: string;
  partnerName: string;
  firstName: string;
  lastName: string;
  institutionId: string;
  nonUsSupported: boolean;
  whiteGloveEligible?: boolean;
  campaignName?: string;
  labels?: { disclaimer: string; message: string; title: string }[];
}

export enum InstitutionIds {
  SUNRISE = 'b0c290e9-67e5-4973-b3e5-8b2720088ee8',
}

export enum OnboardingType {
  DIRECT = 'direct',
  CONNECT = 'connect',
}
